export type AuthStore = {
  loading: boolean
  error: string | null
  userType: UserTypes | null
  email: string | null
  role: string | null
}

export enum UserTypes {
  CUSTOMER = 'customer',
  SALES = 'sales',
  SUPER_USER = 'superuser'
}
